const VIDLET_PURPLE = "#8a2063";
const VIDLET_ORANGE = "#f3591b";
const VIDLET_TEAL = "#508790";

const colors = {
  vidletColors: {
    addButton: "#423c3c",
    aiColor: "#508790",
    deleteButton: "#c41e1c",
    publishButton: "#432055",
    duplicateButton: "#423c3c",
    defaultButton: "#B1B1B1",
    gray: "#B1B1B1",
    blue: "#3E639E",
    green: "#5B9E3E",
    darkGray: "#5d5b5b",
    purple: "#6e275b",
    deepBlue: "#46679C",
    magenta: "#8a2063",
    orange: VIDLET_ORANGE,
    hotpink: "#fb2093",
    contactNote: "#dfe4ed",
    hydra: "#3E639E",

    hydraLight: "#abbad4",
    tealBlue: VIDLET_TEAL,
    purple: VIDLET_PURPLE,
    selfService: "#8F4ED7",
    selfServiceHover: "#7B3FBD",
  },
  script: {
    moderatedColor: VIDLET_TEAL,
    focusGroupColor: "#7bbf86",
    mobilePublishedColor: VIDLET_ORANGE,
    mobileDraftColor: VIDLET_PURPLE,
    invitedColor: "#999999",
    inprogressColor: "#5d5b5b",
    completedColor: "#333333",
    paidColor: VIDLET_PURPLE,
  },

  saveButton: {
    main: "#3c869f",
    light: "#32a4c9",
  },

  background: {
    default: "#f8f9fa",
    imported: "#f3eae8",
  },

  text: {
    main: "#67748e",
  },

  white: {
    main: "#ffffff",
    alpha92: "rgba(255, 255, 255, 0.92)",
    alpha28: "rgba(255, 255, 255, 0.28)",
  },

  black: {
    light: "#141414",
    main: "#000000",
  },

  primary: {
    light: "#e92c92",
    imported: "#de5a38",
    main: VIDLET_PURPLE,
  },

  secondary: {
    light: "#96a2b8",
    main: "#8392ab",
  },

  info: {
    light: "#3acaeb",
    main: "#17c1e8",
  },

  success: {
    light: "#95dc39",
    main: "#258750",
  },

  warning: {
    light: "#faaf00",
    main: VIDLET_ORANGE,
  },

  error: {
    main: "#ea0606",
    dark: "#c70505",
  },

  light: {
    main: "#e9ecef",
  },

  dark: {
    main: "#344767",
  },

  grey: {
    100: "#f8f9fa",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  inputColors: {
    borderColor: { main: "#d2d6da", focus: "#35d1f5" },
    boxShadow: "#81e3f9",
    error: "#fd5c70",
    success: "#66d432",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
